
const INIT_STATE = {
    dashboardData: [],
    monthlyAnalysis : []
}

export default (state = INIT_STATE, action) => {
    switch (action.type) {

        case 'gettingAdminDashboard_START':{
            return {
                ...state,
                fetchingLoader:true
            };
        }

        case 'getAdminDashboard_SUCCESS':{
            return {
                ...state,
                dashboardData: [...action.payload.Record] ,
                fetchingLoader:false
            };
        }
        case 'getMonthlyOverview_SUCCESS':{
            return {
                ...state,
                monthlyAnalysis: action.payload.Record ,
                fetchingLoader:false
            };
        }
        case 'getRevenueDashboard_SUCCESS':{
            return {
                ...state,
                revenueOverview: action.payload.Record ,
                
            };
        }

        


        
        default:
            return state;
    }
}
